import { render, staticRenderFns } from "./couponEntrance.vue?vue&type=template&id=744706bf&scoped=true&"
import script from "./couponEntrance.vue?vue&type=script&lang=js&"
export * from "./couponEntrance.vue?vue&type=script&lang=js&"
import style0 from "./couponEntrance.vue?vue&type=style&index=0&id=744706bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744706bf",
  null
  
)

export default component.exports